import React from "react";
import DataTable from "react-data-table-component";

const columns = [
  {
    name: "Vehicle",
    selector: (row) => row.vehicle,
  },
  {
    name: "Driver",
    selector: (row) => row.driver,
  },
  {
    name: "Meter Check-In",
    selector: (row) => 123,
  },
  {
    name: "Meter Check-Out",
    selector: (row) => 345,
  },
  {
    name: "Distance KM",
    selector: (row) => 40,
  },
  {
    name: "Fuel Avg",
    width: "100px",
    selector: (row) => row.average,
  },
  {
    name: "Total Fuel Cost",
    selector: (row) => 5000,
  },
  {
    name: "Date",
    selector: (row) => "22-2-2022",
  },
];
const customStyles = {
  rows: {
    style: {
      minHeight: "42px",
      background: "white",
    },
  },
  header: {
    style: {
      color: "#4EAF50",
    },
  },
  headCells: {
    style: {
      justifyContent: "center",
      backgroundColor: "#4EAF50",
      fontStyle: "normal",
      color: "#FFFFFF",
      fontWeight: "500",
      fontSize: "12px",
      lineHeight: "18px",
    },
  },
  cells: {
    style: {
      justifyContent: "center",
      fontStyle: "normal",
      color: "#737373",
      fontWeight: "400",
      fontSize: "12px",
      lineHeight: "18px",
      borderLeft: "1px solid #4EAF51",
      borderBottom: "1px solid #4EAF51",
    },
  },
  table: {
    style: {
      background: "#EBEBEB",
      marginBottom: "20px",
      borderRight: "1px solid #4EAF51",
    },
  },
};

function VExpense({ data }) {
  return (
    <DataTable
      columns={columns}
      data={data}
      highlightOnHover={true}
      customStyles={customStyles}
      pointerOnHover={true}
    />
  );
}

export default VExpense;
